let beep = new Audio('/beep-21.wav')
beep.volume = 0.25

let unlock = new Audio(
  '/zapsplat_husehold_bolt_metal_lock_or_unlock_held_in_hand_002_69161.mp3'
)

let error_beep = new Audio('/error_beep.mp3')

export function playBeep() {
  beep.play()
}

export function playUnlock() {
  unlock.play()
}

export function playErrorBeep() {
  error_beep.play()
}
